exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.notifications-title{font-family:Open Sans,sans-serif;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;color:#2c2c2c;text-transform:uppercase}.notifications-container{margin-bottom:16px}.notifications-item{margin-left:24px;display:flex;flex-direction:row;align-items:center;justify-content:space-between}.notifications-item .notifications-toggle{margin-right:24px;margin-top:7px;justify-content:flex-end}.notification-text{transition:all .3s ease-in-out;overflow:hidden;margin-top:6px;margin-left:40px;margin-right:32px;font-family:Open Sans,sans-serif;font-size:12px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-.3px;color:#9b9b9b}.closed{height:0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserSettings/NotificationsSettings/NotificationsSettings.scss
// module id = 1681
// module chunks = 0